import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AdminLayout } from "@/components/AdminLayout";
import { api, errText } from "@/lib/api";
import { leadName } from "@/lib/leads";
import { LeadPhotos, LeadProject, LeadCustomer, LeadSource, LeadActions, LeadAdminNotes } from "@/components/leads/LeadPanels";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function LeadDetail() {
  const { id } = useParams();
  const [lead, setLead] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/revival-leads/${id}`).then((r) => setLead(r.data)).catch((e) => {
      setMissing(true);
      toast.error(errText(e));
    });
  }, [id]);

  if (missing) {
    return (
      <AdminLayout title="Lead not found">
        <Link to="/admin/leads" className="text-sm underline underline-offset-4">← Back to leads</Link>
      </AdminLayout>
    );
  }
  if (!lead) return <AdminLayout title="Lead"><p className="text-gray-400">Loading...</p></AdminLayout>;

  return (
    <AdminLayout title={`${lead.lead_number} — ${leadName(lead)}`}>
      <Link to="/admin/leads" data-testid="back-to-leads" className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-black transition-colors duration-150 -mt-4 mb-6">
        <ArrowLeft size={14} /> All leads
      </Link>
      <div className="grid lg:grid-cols-3 gap-6 items-start" data-testid="lead-detail">
        <div className="lg:col-span-2 space-y-6">
          <LeadPhotos photos={lead.photos} />
          <LeadProject lead={lead} />
          <LeadAdminNotes lead={lead} onUpdate={setLead} />
        </div>
        <div className="space-y-6">
          <LeadActions lead={lead} onUpdate={setLead} />
          <LeadCustomer lead={lead} />
          <LeadSource lead={lead} />
        </div>
      </div>
    </AdminLayout>
  );
}
